import * as React from 'react';
import { ArticleHeading1, ModalWindow, ArticleParagraph1 } from '@cian/ui-kit';
import { VideoPlayer } from '../../components/VideoPlayer';
import { VideoPreview } from '../../components/VideoPreview';
import { VideoModalContent } from '../../components/VideoModalContent';

interface IVideoModalProps {
  open: boolean;
  onClose(): void;
  videoId: string;
  title?: string;
  description?: string;
  videoPreviewUrl: string;
}

export function VideoModal({ open, onClose, videoId, videoPreviewUrl, title, description }: IVideoModalProps) {
  return (
    <ModalWindow
      open={open}
      onClose={onClose}
      fixed={false}
      size="M"
      header={<ArticleHeading1>{title}</ArticleHeading1>}
      content={
        <VideoModalContent
          media={<VideoPlayer videoId={videoId} preview={<VideoPreview url={videoPreviewUrl} />} />}
          description={<ArticleParagraph1>{description}</ArticleParagraph1>}
        />
      }
    />
  );
}
